<template>
  <b-container fluid>
    <filter-search
      :defaultDate="$route.params.defaultDate"
      ref="filterSearch"
      @onSelectDate="loadPackages(1)"
      @onSearch="loadPackagesBySearchButton(1)"
    ></filter-search>
    <b-table
      hover
      show-empty
      responsive
      ref="packages"
      id="data_table"
      :fields="fields"
      :items="items"
      :busy="visible"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      @row-hovered="rowHowered"
      @row-unhovered="rowUnhowered"
      class="mt-3"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу"
      :sort-compare="mySortCompare"
    >
      <template v-slot:cell(package)="data">
        <b><p class="mb-0">{{ data.item.pid }}<span v-if="data.item.pid !== data.item.chainid">/{{ data.item.chainid }}</span></p></b>
        <div class="status-wrapper d-flex align-items-center">
          <b-badge :variant="convertToStatusColor(data.item.status)">{{ data.item.status_name }}</b-badge>
          <div v-if="data.item.decline_reasons.length > 0" @click="showDeclineReasons(data.item.decline_reasons)" class="reply-icon-wrapper ml-2">
            <font-awesome-icon class="text-danger" icon="question-circle"/>
          </div>
        </div>
        <b-button
          :href="data.item.docsign_url"
          target="_blank"
          class="d-flex align-items-center mt-2"
          style="max-width: 110px"
          size="sm"
          v-if="data.item.docsign_url && (data.item.docsign_url !== null)"
          variant="primary">
          <font-awesome-icon icon="fa-solid fa-fingerprint" class="mr-1" />Подписать
        </b-button>
      </template>
      <template v-slot:cell(waybill)="data">
        <div v-if="data.item.info[1] && ((data.item.info[1].length - 1) > 9)" class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[1]" :key="item">
            <span v-if="index < 9">{{ item }}, </span>
            <span v-else-if="index === 9">{{ item }}...</span>
          </div>
        </div>
        <div v-else class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[1]" :key="item">
            <span v-if="(index < (data.item.info[1].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </div>
        </div>
      </template>
      <template v-slot:cell(vehicle)="data">
        <div v-if="data.item.info[4] && ((data.item.info[4].length - 1) > 9)" class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[4]" :key="item">
            <span v-if="index < 9">{{ item }}, </span>
            <span v-else-if="index === 9">{{ item }}...</span>
          </div>
        </div>
        <div v-else class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[4]" :key="item">
            <span v-if="(index < (data.item.info[4].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </div>
        </div>
      </template>
      <template v-slot:cell(place_of_delivery)="data">
        <p v-if="data.item.info[8]" class="mb-0">{{ data.item.info[8][0] }}</p>
      </template>
      <template v-slot:cell(organization)="data">
        <div v-if="data.item.info[3] && ((data.item.info[3].length - 1) > 3)" class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[3]" :key="item">
            <span v-if="index < 3">{{ item }}, </span>
            <span v-else-if="index === 3">{{ item }}...</span>
          </div>
        </div>
        <div v-else class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[3]" :key="item">
            <span v-if="(index < (data.item.info[3].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </div>
        </div>
      </template>
      <template v-slot:cell(modify_datetime)="data">
        <div class="user-creator-wrapper">
          <b-button class="icon-wrapper" v-b-tooltip.hover title="Создатель">
            <font-awesome-icon icon="user"/>
          </b-button>
          <span class="user-creator">{{ data.item.sender }}</span>
        </div>
        <div class="created-date-wrapper">
          <b-button class="icon-wrapper" v-b-tooltip.hover :title="getDateTooltip(data.item.creationdate, data.item.getlastmodified)">
            <font-awesome-icon icon="clock"/>
          </b-button>
          <span class="created-date">{{ getDate(data.item.creationdate, data.item.getlastmodified) }}</span>
        </div>
        <div class="destination-wrapper">
          <b-button class="icon-wrapper" v-b-tooltip.hover title="Получатель">
            <font-awesome-icon icon="arrow-alt-circle-right"/>
          </b-button>
          <span class="destination"><b-badge :variant="convertToDirectionColor(data.item.receiver)">{{ convertToDirection(data.item.receiver) }}</b-badge></span>
        </div>
      </template>
      <template v-slot:cell(actions)="row">
        <actions
          ref="actions"
          :visible="row.item.actions.visible"
          :target="row.index.toString()"
          :status="row.item.status"
          :manifest="row.item.manifest"
          @open_documents="openDocuments(row)"
          @edit_package="editPackage(row)"
          @edit_package_as_new="editPackageAsNew(row)"
          @loadCommitmentStatement="getCommitmentStatement($event, row)"
          @loadEmptyContRegTable="getEmptyContRegTable($event, row)"
          @download_manifest="getManifest($event, row)">
        </actions>
      </template>
      <template slot="row-details" slot-scope="row">
        <card :attachmentWidth="attachmentWidth" :row="row" @onOpenDocument="openDocument($event)"></card>
      </template>
      <div slot="table-busy" class="text-xl-center text-lg-center text-md-center text-sm-left text-left text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загружаем данные...</strong>
      </div>
    </b-table>
    <b-pagination align="right"
                  prev-text="&lt;"
                  first-text="&lt;&lt;"
                  next-text="&gt;"
                  last-text="&gt;&gt;"
                  size="sm"
                  :total-rows="pages*10*2"
                  :per-page="perPage"
                  @change="loadPackagesByPagination"
                  v-model="currentPage">
    </b-pagination>
    <open-document-modal @resetModalProps="resetProps"></open-document-modal>
    <edit-commitment-statement-modal></edit-commitment-statement-modal>
    <b-modal id="declineReasons" class="text-center" size="md" hide-footer>
      <template slot="modal-title">
        <div v-html="'Причины отклонения пакета'"></div>
      </template>
      <div v-for="(item, index) in declineReasons" :key="index" style="font-size: 14px">
        <div>{{ index + 1 }}. {{ item.ResultDescription }}</div>
      </div>
    </b-modal>
    <div id="myTestDiv" style="position: absolute; top: -794px; left: 12000px; border: 1px solid black; width: 1123px; height: 794px; padding: 20px 20px;"></div>
    <div id="myTest" style="position: absolute; top: -1123px; left: 12000px; border: 1px solid black; width: 794px; height: 1123px; padding: 20px 20px;"></div>
  </b-container>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import FilterSearch from './PackagesListFilterSearch'
  import Actions from './PackagesListActions'
  import Card from './DocumentCard'
  import OpenDocumentModal from './modals/OpenDocument'
  import EditCommitmentStatementModal from './modals/EditCommitmentStatement'
  import { converterMixin } from './mixins/converterMixin'
  import { getManifestMixin } from './mixins/getManifestMixin'
  import { processDocumentsMixin } from './mixins/processDocumentsMixin'
  import html2pdf from './../../node_modules/html2pdf.js/dist/html2pdf.js'
  import moment from 'moment'
  export default {
    name: "PackagesList",
    mixins: [converterMixin, getManifestMixin, processDocumentsMixin],
    components: {
      EditCommitmentStatementModal,
      FilterSearch,
      Actions,
      OpenDocumentModal,
      Card
    },
    data () {
      return {
        modified: false,
        fields: [
          { key: 'package', label: 'Пакет' },
          { key: 'waybill', label: '№ накладной' },
          { key: 'organization', label: 'Организации' },
          { key: 'vehicle', label: 'Транспорт' },
          { key: 'place_of_delivery', label: 'Место доставки' },
          { key: 'modify_datetime', label: 'Параметры' },
          { key: 'actions', label: 'Действия', tdClass: 'actions-fixed-width', stickyColumn: true }
        ],
        items: [],
        currentPage: 1,
        totalRows: 1,
        filter: null,
        filterOn: ['id', 'vehicle', 'waybill', 'status_name'],
        perPage: 0,
        pageOptions: [10, 20, 50],
        sortBy: 'modify_datetime',
        sortDesc: false,
        sortDirection: 'asc',
        documentAdditionalTable: null,
        documentGeneralInformation: null,
        documentName: null,
        documentHtml: null,
        documentXml: null,
        documentId: null,
        documentHtmlForPdf: null,
        documentFileName: null,
        mergedDocumentXml: null,
        attachmentWidth: null,
        commitmentStatementRow: null,
        declineReasons: []
      }
    },
    computed: {
      ...mapState(
        {
          portals: state => state.packages.portals,
          packages: state => state.packages.packages,
          visible: state => state.packages.visible,
          documents: state => state.packages.documents,
          statuses: state => state.packages.statuses,
          userInfo: state => state.authorization.userInfo,
          pages: state => state.packages.pages,
          pids: state => state.packages.pids,
          message: state => state.socket.message,
          connection: state => state.socket.connection,
          packageDocumentsList: state => state.commissionShipment.packageDocumentsList
        }
      )
    },
    watch: {
      message (val) {
        console.log(val)
        const parsedData = eval(JSON.parse(val.data))
        if (parsedData.length > 0) {
          for (let i = 0; i < parsedData.length; i++) {
            const checkoutStatusPackage = this.items.filter((item) => {
              return item.pid === parsedData[i].pid
            })
            if ((checkoutStatusPackage.length > 0) && (parsedData[i].status === 107)) { // архивный пакет
              const ind = this.items.findIndex((item) => {
                return item.pid === parsedData[i].pid
              })
              this.items.splice(ind, 1)
            } else if ((checkoutStatusPackage.length === 0) && (parsedData[i].status !== 107)) { // новый пакет, которого нет в списке
              parsedData[i].documents = null
              parsedData[i].actions = { visible: false }
              parsedData[i].index = '0'
              parsedData[i].waybill = parsedData[i].info[1]
              parsedData[i].vehicle = parsedData[i].info[4]
              parsedData[i].manifest = { id: null, progress: false }
              parsedData[i].docsign_url = parsedData[i].docsign_url === '' ? null : parsedData[i].docsign_url
              parsedData[i]._rowVariant = 'success'
              this.items.unshift(parsedData[i])
              setTimeout(() => {
                parsedData[i]._rowVariant = ''
                this.$refs.packages.refresh()
              }, 2000)
            } else if ((checkoutStatusPackage.length > 0) && (parsedData[i].status !== 107)) { // пакет из списка
              checkoutStatusPackage[0]._rowVariant = 'success'
              checkoutStatusPackage[0].status_name = parsedData[i].status_name
              checkoutStatusPackage[0].status = parsedData[i].status
              checkoutStatusPackage[0].decline_reasons = parsedData[i].decline_reasons
              checkoutStatusPackage[0].docsign_url = parsedData[i].docsign_url === '' ? null : parsedData[i].docsign_url
              setTimeout(() => {
                checkoutStatusPackage[0]._rowVariant = ''
                this.$refs.packages.refresh()
              }, 2000)
            }
            if (parsedData[i].docsign_url && (parsedData[i].docsign_url.length > 0)) {
              this.showSocketMessageToast(parsedData[i])
            }
          }
          this.$refs.packages.refresh()
        }
      }
    },
    mounted () {
      this.loadPackages(1)
      this.attachmentWidth = Math.round((window.innerWidth - 16 * 9 - 30) / 5)
      if (this.attachmentWidth < 300) {
        this.attachmentWidth = 300
      } else if (this.attachmentWidth > 400) {
        this.attachmentWidth = 400
      }
      localStorage.removeItem('decline_reasons')

      /* setInterval(() => {
        if ((this.connection.bufferedAmount == 0) && (this.connection.readyState == 1)) {
          this.connection.send(JSON.stringify({ key: 'test', data: 'Test test test'}))
        }
      }, 6000) */
    },
    methods: {
      showSocketMessageToast (data) {
        const h = this.$createElement
        const vNodesMsg = h(
          'p',
          { class: ['text-center', 'mb-0'] },
          [
            h('b-button', { props: { variant: 'primary', size: 'sm', target: '_blank', href: data.docsign_url } },
              [
                h('font-awesome-icon', { props: { icon: 'fa-solid fa-fingerprint' } }),
                h('span', { class: 'ml-1' }, 'Подписать')
              ]
            ),
          ]
        )
        const vNodesTitle = h(
          'p',
          [
            h('strong', `№ ${data.pid}, № ${data.info['1'] }`),
            h('br'),
            h('strong', 'ожидает подписи')
          ]
        )
        this.$bvToast.toast([vNodesMsg], {
          title: [vNodesTitle],
          solid: true,
          variant: 'default',
          noAutoHide: true,
          appendToast: true,
          toaster: 'b-toaster-bottom-right'
        })
      },
      moment: function (date) {
        moment.locale('ru')
        return moment(date)
      },
      getDatepickerDate () {
        let ISODate = null
        if (this.$refs.filterSearch.datePickerValue !== null) {
          if (this.$refs.filterSearch.datePickerValue.end !== null) {
            const start = this.moment(this.$refs.filterSearch.datePickerValue.start).add(3, 'hours').format('YYYY-MM-DD HH:mm')
            const end = this.moment(this.$refs.filterSearch.datePickerValue.end).add(3, 'hours').format('YYYY-MM-DD HH:mm')
            ISODate = {
              datetime_start: new Date(start.replace(/-/g, '/').replace('T', ' ')).toISOString(),
              datetime_end: new Date(end.replace(/-/g, '/').replace('T', ' ')).toISOString()
            }
            localStorage.setItem('datePickerValue_start', this.$refs.filterSearch.datePickerValue.start.replace(/-/g, '/').replace('T', ' '))
            localStorage.setItem('datePickerValue_end', this.$refs.filterSearch.datePickerValue.end.replace(/-/g, '/').replace('T', ' '))
          } else {
            const start = this.moment(this.$refs.filterSearch.datePickerValue.start).add(3, 'hours').format('YYYY-MM-DD HH:mm')
            const end = this.moment(start).add(1, 'days').subtract(1, 'seconds').format('YYYY-MM-DD HH:mm')
            this.$refs.filterSearch.datePickerValue.end = this.moment(this.$refs.filterSearch.datePickerValue.start).add(1, 'days').subtract(1, 'seconds').format('YYYY-MM-DD HH:mm')
            ISODate = {
              datetime_start: new Date(start.replace(/-/g, '/').replace('T', ' ')).toISOString(),
              datetime_end: new Date(end.replace(/-/g, '/').replace('T', ' ')).toISOString()
            }
            localStorage.setItem('datePickerValue_start', start.replace(/-/g, '/').replace('T', ' '))
            localStorage.setItem('datePickerValue_end', end.replace(/-/g, '/').replace('T', ' '))
          }
        }
        return ISODate
      },
      loadPackagesByPagination (page) {
        this.loadPackages(page, { pagination: true }, { search: false })
      },
      loadPackagesBySearchButton (page) {
        this.loadPackages(page, { pagination: false }, { search: true })
      },
      loadPackages (page, obj = { pagination: false }, search = { search: false }) {
        this.setVisible(true)
        return new Promise((resolve, reject) => {
          const params = {
            page: page,
            key: this.$refs.filterSearch.searchText, // общий поиск
            pid: this.$refs.filterSearch.searchTextByPid, // поиск по номеру пакета
            prop: this.$refs.filterSearch.selectedCategory, // фильтр по категории
            statuses: (this.$refs.filterSearch.selectedStatus === null) ? [] : this.$refs.filterSearch.selectedStatus, // фильтр по статусам
            pids: ''
          }
          if (search.search === true) {
            this.currentPage = 1
          }
          if (obj.pagination === true) {
            const myPids = this.pids.slice()
            params.pids = myPids.splice(((page - 1) * 10), 10)
          }
          if (!this.$refs.filterSearch.searchByPackageNumber) {
            Object.assign(params, this.getDatepickerDate())
            this.getStatuses({ portalId: this.$refs.filterSearch.portalId, queryParams: this.getDatepickerDate() }).then(
              () => {
                this.getPackagesFromPortal({ portalId: this.$refs.filterSearch.portalId, queryParams: params }).then(
                  () => {
                    this.items = JSON.parse(JSON.stringify(this.packages))
                    this.totalRows = this.packages.length
                    resolve()
                  },
                  error => {
                    reject(error)
                  }
                )
              },
              error => {
                reject(error)
              }
            )
          } else {
            this.getPackagesFromPortal({ portalId: this.$refs.filterSearch.portalId, queryParams: params }).then(
              () => {
                this.items = JSON.parse(JSON.stringify(this.packages))
                this.totalRows = this.packages.length
                resolve()
              },
              error => {
                reject(error)
              }
            )
          }
        })
      },
      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
      },
      rowHowered (item) {
        item.actions.visible = true
      },
      rowUnhowered (item) {
        item.actions.visible = false
      },
      getDateTooltip (createDateTime, modifyDateTime) {
        const create = this.moment(createDateTime).format('DD.MM.YYYY')
        const modify = this.moment(modifyDateTime).format('DD.MM.YYYY')
        if (create === modify) {
          return 'Дата создания'
        } else {
          return 'Дата создания/Дата модификации'
        }
      },
      getDate (createDateTime, modifyDateTime) {
        const create = this.moment(createDateTime).format('DD.MM.YYYY')
        const modify = this.moment(modifyDateTime).format('DD.MM.YYYY')
        if (create === modify) {
          return create
        } else {
          return create + '/' + modify
        }
      },
      mySortCompare (aRow, bRow, key) {
        const a = aRow[key]
        const b = bRow[key]
        if (key === 'modify_datetime') {
          return new Date(b) - new Date(a)
        }
      },
      editPackage (row) {
        const declineReasons = row.item.decline_reasons.filter((item) => {
          return item.ResultCategory.toUpperCase() === 'ERROR'
        })
        this.setDeclineReasons(declineReasons)
        this.getPackageDocumentsList(row.item.pid).then(
          () => {
            const hasCommissionshipment = this.packageDocumentsList.documents.find((item) => {
              return item.type.toLowerCase() === 'commissionshipment.cfg.xml'
            })
            if (!(hasCommissionshipment === undefined)) {
              this.$router.push(`/packages/commission-shipment/${row.item.pid}`)
            } else {
              this.$bvToast.toast('Обратитесь в техническую поддержку.', {
                title: 'Редактирование пакета невозможно!',
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true
              })
            }
            console.log('this.packageDocumentsList ', this.packageDocumentsList)
          },
          (error) => {
            console.log(error)
          }
        )
      },
      editPackageAsNew (row) {
        this.getPackageDocumentsList(row.item.pid).then(
          () => {
            const hasCommissionshipment = this.packageDocumentsList.documents.find((item) => {
              return item.type.toLowerCase() === 'commissionshipment.cfg.xml'
            })
            if (!(hasCommissionshipment === undefined)) {
              this.$router.push({ path: `/packages/commission-shipment/${row.item.pid}`, query: { new: 'true' } })
            } else {
              this.$bvToast.toast('Обратитесь в техническую поддержку.', {
                title: 'Редактирование пакета невозможно!',
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true
              })
            }
          },
          (error) => {
            console.log(error)
          }
        )
      },
      openDocuments (row) {
        row.toggleDetails()
        if (row.item.documents === null) {
          this.loadPackageDocuments({ portalId: this.$refs.filterSearch.portalId, package: row.item.pid }).then(
            () => {
              row.item.documents = this.documents
              this.processDocuments(row)
            },
            error => {
              console.log(error)
            }
          )
        } else {
          row.item.documents = null
        }
      },
      openDocument (document) {
        this.documentFileName = document.type
        this.documentHtml = document.htmlAfterProcessing
        this.documentXml = document.xml
        this.documentId = document.pid
        this.documentName = document.documentName.replace('<br>', ' ')
        if (document.htmlForPdfCommissionShipment && document.htmlForPdfCommissionShipment.length > 0) {
          this.documentHtmlForPdf = document.htmlForPdfCommissionShipment
        } else {
          this.documentHtmlForPdf = document.htmlForPdf
        }
        this.documentAdditionalTable = document.additionalTable
        this.documentGeneralInformation = document.generalInformation
        this.mergedDocumentXml = document.mergedDocumentXml
        this.$root.$emit('bv::show::modal', 'openDocument', event)
      },
      checkHtml (documents) {
        const hasHtml = documents.filter(document => document.html.length > 0)
        return hasHtml.length
      },
      resetProps () {
        this.documentHtml = null
        this.documentName = null
        this.documentXml = null
        this.documentId = null
        this.documentHtmlForPdf = null
      },
      downloadPDFManifest (row, pages, opt) {
        this.rowInProgress = row
        const promise = new Promise((resolve) => {
          let worker = html2pdf().set(opt).from(pages[0]).toPdf()
          pages.slice(1).forEach(function (page) {
            worker = worker.get('pdf').then(function (pdf) {
              pdf.addPage()
            }).from(page).toContainer().toCanvas().toPdf()
          })
          worker.save().then(() => {
            resolve()
          })
        })
        promise.then(() => {
          this.rowInProgress.item.manifest = { id: null, progress: false }
        })
      },
      replaceCommaLine (data) {
        const dataToArray = data.split(',').map(item => item.trim())
        return dataToArray.join('<br>')
      },
      getCommitmentStatement (event, row) {
        this.commitmentStatementRow = row
        event.stopPropagation()
        this.$root.$emit('bv::show::modal', 'editCommitmentStatement', event)
      },
      getEmptyContRegTable (event, row) {
        let host = ''
        switch (this.userInfo.piportals[0].alias) {
          case 'afb':
            host = 'app.fill-bill.ru'
            break
          case 'pi':
            host = 'fill-bill.prominvest.ru'
            break
          case 'bs':
            host = 'blacksea.fill-bill.ru'
            break
          case 'afbpp':
            host = 'app-predprod.ctm'
            break
          default:
            break
        }
        const reportexcelzip = {
          host: host,
          packageId: row.item.pid
        }
        this.getReportExcelZip(reportexcelzip).then(
          (value) => {
            const fileName = 'Empty_container_registration_table.zip'
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              const downloadBlob = new Blob([value.data], { type: value.headers['Content-Type'] })
              window.navigator.msSaveOrOpenBlob(downloadBlob, fileName)
            } else {
              try {
                const downloadUrl = window.URL.createObjectURL(new Blob([value.data]), { type: value.headers['Content-Type'] })
                const link = document.createElement('a')
                link.href = downloadUrl
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
                setTimeout(() => {
                  link.remove()
                  window.URL.revokeObjectURL(downloadUrl)
                }, 2000)
              } catch (error) {
                console.log(error)
              }
            }
          },
          (error) => {
            console.log(error)
          }
        )
      },
      showDeclineReasons (declineReasons) {
        this.declineReasons = declineReasons.filter((item) => {
          return item.ResultCategory.toUpperCase() === 'ERROR'
        })
        this.$root.$emit('bv::show::modal', 'declineReasons', event)
      },
      ...mapActions('packages',
        [
          'getPackagesFromPortal',
          'loadPackageDocuments',
          'getStatuses',
          'getReportExcelZip',
          'getReport4',
          'getReport4emptycont_new'
        ],
      ),
      ...mapActions({
        getPackageDocumentsList: 'commissionShipment/getPackageDocumentsList',
      }),
      ...mapMutations({
        setDeclineReasons: 'packages/setDeclineReasons',
        setVisible: 'packages/setVisible'
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
